import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import moment from "moment/moment";
import productAPI from "../../services/productapi";
import Table from "react-bootstrap/Table";

const ProductViewModal = ({ invModal, productId, change }) => {
    const [productModal, setProductModal] = useState(invModal);
    const [productDetails, setProductDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const handleProductClose = () => {
        setProductModal(false);
        change();
    };

    useEffect(() => {
        setIsLoading(true);
        const fetchDetail = async () => {
            try {
                const data = await productAPI.getProductsData(productId);
                if (data) {
                    setProductDetails({ ...data.data });
                    setIsLoading(false);
                }
            } catch (e) {
                console.error("Failed to fetch branch:", e);
            }
        };
        fetchDetail();
    }, [productId]);

    const indCurrency = "₹";

    return (
        <div>
            <Modal show={productModal} onHide={handleProductClose} size="lg" centered>
                {isLoading ? (
                    "Product detail is loading...."
                ) : (
                    <>
                        <div id="productCapture">
                            <div className="justify-content-between align-items-start bg-light w-100 p-4">
                                <div className="w-100">
                                    <h4 className="fw-bold my-2">
                                        {productDetails.productName}
                                    </h4>
                                </div>
                                <div className="w-100">
                                    <p>{productDetails.description}</p>
                                </div>
                            </div>
                            <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
                                <div className="w-100">
                                    <p className="fw-bold my-2">
                                        Category : {productDetails.category ? productDetails.category.categoryName : 'Not Assigned'}
                                    </p>
                                </div>
                                <div className="w-100">
                                    <p className="fw-bold my-2">
                                        Brand : {productDetails.brand ? productDetails.brand.name : 'Not Assigned'}
                                    </p>
                                </div>
                            </div>

                            {/* Display Product Items in Table Format */}
                            <div className="p-4">
                                <h3 className="fw-bold">Product Item Details</h3>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Price</th>
                                            <th>MRP</th>
                                            <th>Unit</th>
                                            <th>Ref Code</th>
                                            <th>Sync Date</th>
                                            <th>Updated At</th>
                                            <th>Veg Flag</th> {/* Added column for Veg Flag */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productDetails.items.map((item) => (
                                            <tr key={item.itemId}>
                                                <td>
                                                    <img
                                                        src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${item.image}`}
                                                        alt={productDetails.productName}
                                                        style={{ width: "50px", height: "auto" }}
                                                    />
                                                </td>
                                                <td>{indCurrency} {item.sellPrice}</td>
                                                <td>{indCurrency} {item.mrp}</td>
                                                <td>{item.unit} {item.unitName}</td>
                                                <td>{item.refCode}</td>
                                                <td>{moment(item.syncDate).format("YYYY-MM-DD HH:mm")}</td>
                                                <td>{moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}</td>
                                                <td>
                                                    {item.vegFlag === 1 ? (
                                                        <span
                                                            style={{
                                                                backgroundColor: "green",
                                                                color: "white",
                                                                padding: "5px 10px",
                                                                borderRadius: "5px"
                                                            }}
                                                        >
                                                            Veg
                                                        </span>
                                                    ) : (
                                                        <span
                                                            style={{
                                                                backgroundColor: "red",
                                                                color: "white",
                                                                padding: "5px 10px",
                                                                borderRadius: "5px"
                                                            }}
                                                        >
                                                            No
                                                        </span>
                                                    )}

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Related Products */}
                            <div className="p-4">
                                <h3 className="fw-bold">Related Product Details</h3>
                                <div className="tags-container">
                                    {productDetails.relatedProductsDetails.map((relatedProduct) => (
                                        <span key={relatedProduct.id} className="tag">
                                            {relatedProduct.productName}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="pb-4 px-4">
                            <Row>
                                <Col md={6}>
                                    <Button
                                        variant="danger"
                                        className="d-block w-100"
                                        onClick={handleProductClose}
                                    >
                                        Close
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </>
                )}
            </Modal>
            <hr className="mt-4 mb-3" />
        </div>
    );
};

export default ProductViewModal;
